export default __webpack_public_path__ + "static/media/large-grows.4a04167c.png";